import React from 'react';
import NotesApp from './NotesApp';

function NotesWrapper() {
  return (
    <>
      <NotesApp />
    </>
  );
}

export default NotesWrapper;
